import axios from "axios";

const SERVER_API_URL = process.env.REACT_APP_API_URL;
const TIMEOUT = 1 * 60 * 1000;
axios.defaults.timeout = TIMEOUT;
axios.defaults.baseURL = SERVER_API_URL;

const setupAxiosInterceptors = () => {
  const onRequestSuccess = (config: any) => {
    return config;
  };
  const onResponseSuccess = (response: any) => response;
  const onResponseError = (err: Error) => {
    return Promise.reject(err);
  };
  const onRequestError = (err: Error) => {
    return Promise.reject(err);
  };

  axios.interceptors.request.use(onRequestSuccess, onRequestError);
  axios.interceptors.response.use(onResponseSuccess, onResponseError);
};

export default setupAxiosInterceptors;
